module.exports = __webpack_public_path__ + "static/media/spring.1eaed437.svg";